<template>
  <!-- 休日出勤申請詳細画面 -->
  <CCard>
    <CCardHeader>
      <h2>休日出勤申請詳細</h2>
    </CCardHeader>
      <CCardBody>
      <CRow>
          <div class="container">
            <table class="table">
            <tr>
              <th scope="row">申請ユーザ名</th>
              <td>{{ user_name }}</td>
            </tr>
            <tr>
              <th scope="row">申請日</th>
              <td>{{ updated_at }}</td>
            </tr>
            <tr>
              <th scope="row">日付</th>
              <td><span>{{ formatDate(holiday_work_date) }}</span></td>
            </tr>
            <tr>
              <th scope="row">開始予定時間</th>
              <td><span>{{ start_time }}</span></td>
            </tr>
            <tr>
              <th scope="row">終了予定時間</th>
              <td><span>{{ end_time }}</span></td>
            </tr>
              <tr>
              <th scope="row">発生理由</th>
              <td><span>{{ reason }}</span></td>
            </tr>
          </table>
        </div>
      </CRow>
  </CCardBody>
  </CCard>
</template>
  
<script>
import ConstList from './../../ConstList'
import axios from 'axios'
export default {
  name: 'Info',
  data() {
    return {
      holiday_work_date: '',
      start_time: '',
      end_time: '',
      reason: '',
      user_name: '',
      updated_at: "",
    }
  },

    // DBから各種情報を取得
  mounted: function () {
    this.id = this.$route.params.id
    const id = parseInt(this.id);
      axios
        .get((process.env.VUE_APP_API_ORIGIN) + '/admin/holidayWork/' + id)
        .then(response => {
          if (response.data.length === 0) {
            this.errors.push(ConstList.EMPTY)
          }
          const holidayWorkData = response.data
          this.holiday_work_date = holidayWorkData.date
          this.start_time = holidayWorkData.start_time
          this.end_time = holidayWorkData.end_time
          this.reason = holidayWorkData.reason
          this.user_name = holidayWorkData.user_name
          this.updated_at = holidayWorkData.updated_at
          })
        .catch(error => {
         axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          })
        })
  },
  methods: {
    autoTimeSet: function () {
      let start = this.start_time
      let end = this.end_time
      if (((this.start_day !== "") && (this.end_day !== "")) && (this.start_day !== this.end_day)) {
        start.splice(0, 1, ConstList.ALLDAY_ID)
        end.splice(0, 1, ConstList.ALLDAY_ID)
      }
    },
    formatDate(dateStr) {
      // yyyy/mm/ddフォーマット変換
      if (!dateStr) return '';
      const [yyyy, mm, dd] = dateStr.split('-');
      return `${yyyy}/${mm}/${dd}`;
    },
  },
}
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}
</style>